export enum AddressType {
	MAILING = 'Mailing Address',
	LOCALIZED = 'Localized Address',
	OTHER = 'Other Address',
}
